import { render, staticRenderFns } from "./WalletActivity.vue?vue&type=template&id=f1f7d6d2&scoped=true"
import script from "./WalletActivity.vue?vue&type=script&lang=js"
export * from "./WalletActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f7d6d2",
  null
  
)

export default component.exports